import React, { PropTypes } from 'react/addons';
import { Calendar } from 'calendar';

const Month = React.createClass({
  propTypes: {
    weekStarts: PropTypes.number.isRequired,
    dateView: PropTypes.instanceOf(Date),
    children: PropTypes.func.isRequired,
  },

  render() {
    const { weekStarts, dateView, children } = this.props;

    const calendar = new Calendar(weekStarts);
    const weeks = calendar.monthDates(dateView.getFullYear(), dateView.getMonth());

    return (
      <tbody>
        {weeks.map((week, index) => (
          <tr className="ofs-Calendar__Week" key={index}>
            {week.map((date) => children(date))}
          </tr>
        ))}
      </tbody>
    );
  }
});

export default Month;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/Calendar/Month.jsx
 **/